



<div style="margin-right: 32px;">
    <div class="heading">
        <h4 class="title" style="margin-top: 15px;">Excel Upload</h4>
        <h4 class="title" style="margin-top: 15px;" *ngIf="section >= 2" (click)="goback()">goBack</h4>
    </div>
</div>
<!-- <div class="row" style="height:200px">
  <div class="col-md-12">
    <app-agency-field-add></app-agency-field-add>
  </div>
  <div class="col-md-12">
    <app-field-mapping></app-field-mapping>
  </div>
</div> -->

<div class="card-box" style="margin: 2px;padding-bottom: 15px;" *ngIf="booleans">





    <div class="row" style="padding: 0px 0px 23px 10px;" *ngIf="section == 1">


      <div class="col-md-4">
        <h5 class="form-lable">Choose Bank:</h5>
        <p-dropdown [options]="Bank_list" name='Bank_list_gets' (onChange)="fetchuser_1()"  [(ngModel)]="Bank_list_gets" placeholder="Select" optionLabel="y"
            [showClear]="true"></p-dropdown>

    </div>
    <div class="col-md-4">
        <h5 class="form-lable">Choose Product:</h5>
        <select [(ngModel)]="product_list_gets" class="form-control">
            <option *ngFor="let item of product_list" [value]="item._id">{{item.product_type}}</option>
        </select>
    </div>
    <div class="col-md-4">
        <h5 class="form-lable">Choose Portfolio:</h5>
        <p-dropdown [options]="portfolio_list" name='portfolio_list_gets'  [(ngModel)]="portfolio_list_gets" placeholder="Select" optionLabel="y"
            [showClear]="true"></p-dropdown>
    </div>


        <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary" (click)="entry()">Excel Upload</button>
            <button type="button" class="btn btn-primary">Single Entry</button>
            <!-- <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button> -->
            <!-- <button type="button" class="btn btn-primary" >Allocation</button> -->
        </div>
    </div>
    <div class="row" style="padding: 0px 0px 23px 10px;" *ngIf="section >= 2">
        <div class="col-md-12">
            <h5 class="form-lable">Choose Excel file</h5>
            <div class="profile-form-edit">
                <div class="upload-btn-wrapper mt-3">
                    <div style="width:25%; display:flex;"><input type="file" (change)="onFileChange($event)" #fileControl multiple="false" accept=".xlsx" />
                    <i style="color:red;" class="fa fa-window-close" (click)="closeExcel()" aria-hidden="true"></i></div>
                    <a href="assets/Sample_excel.xlsx" download="" class="btn btn-primary"
                        style="margin: 10px;margin-left: 0px;float: right;margin-top: -27px;">Download Sample
                        Document</a>
                    <br>
                    <a *ngIf="section == 3" class="btn btn-primary" (click)="Reloaddatas()" style="margin-left: 0px;float: right; background-color: #747f7f;">Reload Datas</a>
                </div>
                
            </div>
        </div>
        <!-- <div class="col-md-12">
            <h5 class="form-lable">Select Unique value Column:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
            <h5 class="form-lable">Total No.of Cases : 0</h5>
        </div>
        <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary">Check Duplicates</button>
            <button type="button" class="btn btn-primary">Group Customers</button>
        </div> -->

    </div>
    <div class="row" style="padding: 0px 0px 23px 10px;" *ngIf="section == 3">
        <div style="margin-right: 32px;">
            <div>
                <h4 class="title" style="margin-top: 15px;">Field Mapping</h4>
            </div>

            <!-- <div >
              <button (click)="Reloaddatas()">Reloaddatas</button>
            </div> -->
        </div>
        <div class="card-box" style="margin: 2px;padding-bottom: 15px;">
            <div class="row">
                <div class="col-md-3">
                    <!-- <h4 class="title-f">Rak Bucket 2 C3</h4> -->

                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">Bank:</th>
                            <td style="padding: 10px;">{{Bank_list_gets.y}}</td>
                        </tr>

                    </table>
                </div>
                <div class="col-md-9">
                    <!-- <h4 class="title-f">{{Bank_list_gets.y}} Bank</h4> -->

                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">Product : {{product_name}}</th>
                            <td style="padding: 10px;">Portfolio :  {{portfolio_list_gets.y}}</td>
                            <!-- <th style="padding: 10px;">No of Customers:</th>
                            <td style="padding: 10px;">20</td> -->
                            <th style="padding: 10px;">No of Accounts:</th>
                            <td style="padding: 10px;">{{excel_final.length}}</td>
                        </tr>

                    </table>
                </div>
                <div class="col-md-12" style="margin-top: 10px;">
                    <hr>
                </div>
                <!-- <div class="col-md-12">
                    <h4 class="title-f">Task Information</h4>
                    <i class="fa fa-chevron-circle-right"
                        style="margin-top: -29px;font-size: 20px !important; color: #20353f;float: right;"
                        pTooltip="View"></i>
                    <hr>
                </div> -->
                <div class="col-md-6">
                    <h4 class="title-f">Mapped Fields</h4>

                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">System Field</th>
                            <th style="padding: 10px;">Excel Field</th>
                        </tr>

                        <ng-container *ngFor="let item of final_header_excel; let i = index">
                          <tr>
                            <td style="padding: 10px;">{{item.table_head}}</td>
                            <td style="padding: 10px;">{{item.saved_data}}
                                </td>
                            </tr>
                          </ng-container>

                    </table>
                    <div style="margin-top: 15px;">
                        <button class="btn btn-primary" style="margin-right: 10px;">Cancel</button>

                        <button class="btn btn-primary" style="margin-right: 10px;background-color: #747f7f;"
                            (click)="Assign()">Save &
                            Continue</button>
                    </div>

                </div>
                <div class="col-md-6">
                  <div style="text-align:right;"><button class="btn btn-primary" (click)="bulk_upload()">Save</button></div>
                  <!-- <button (click)="bulk_upload()">Save</button> -->
                    <h4 class="title-f">Un Mapped Fields</h4>
                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">Excel Field</th>
                            <th style="padding: 10px;">System Field</th>

                        </tr>


                        <ng-container *ngFor="let item of final_not_match; let i = index">

                          <tr>
                            <td style="padding: 10px;">{{item.final_not_match}}</td>
                            <td style="padding: 10px;">Not Found</td>
                        </tr>
                        <!-- (click)="field_form()"  -->
                        </ng-container>

                    </table>
                    <div style="margin-top: 15px;">
                        <button class="btn btn-primary" style="margin-right: 10px;">Cancel</button>

                        <button class="btn btn-primary" style="margin-right: 10px;background-color: #747f7f;"
                            (click)="Assign()">Save &
                            Continue</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<!-- <p-dialog header="Account Detail" [(visible)]="displayPosition" position="center" [modal]="true"
    [style]="{width: '400px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="row" style="margin-left: 0px;margin-right: 0px;">
        <div class="col-md-12">
            <div class="row" style="padding: 0px 0px 6px 10px;">
                <div class="col-md-12 detail-t">
                    <table style=" width: 100%;">
                        <tr>
                            <th style="padding: 10px;">Account availabile system</th>
                            <td style="padding: 10px;">2200</td>
                        </tr>
                        <tr>
                            <th style="padding: 10px;">New Accounts</th>
                            <td style="padding: 10px;">200</td>
                        </tr>
                        <tr>
                            <th style="padding: 10px;">Re-Activated Accounts</th>
                            <td style="padding: 10px;">60</td>
                        </tr>
                        <tr>
                            <th style="padding: 10px;">Existing Accounts</th>
                            <td style="padding: 10px;">60</td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>
        <div class="col-md-12 text-center">
            <button class="btn btn-primary" (click)="acc_list()">Ok</button>
        </div>
    </div>
</p-dialog> -->

<p-dialog header="Condition Checking" [(visible)]="displayPosition1" position="center" [modal]="true"
    [style]="{width: '300px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="row" style="margin-left: 0px;margin-right: 0px;">
        <div class="col-md-12">
            <div style="padding: 0px 0px 6px 10px;">
                <h5 *ngIf="check >= 1" class="form-lable"
                    style="font-size: 12px;font-weight: 500;color: #000 !important;"><i class="fa fa-check-circle-o"
                        aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #4CAF50;"></i>
                    <!-- <i class="fa fa-times-circle-o" aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #D32F2F;"></i> -->
                    Field availability
                    <i class="fa fa-info-circle" aria-hidden="true"
                        style="font-size: 20px;margin: 3px;color: #03A9F4;"></i>
                </h5>
                <h5 *ngIf="check >= 2" class="form-lable"
                    style="font-size: 12px;font-weight: 500;color: #000 !important;"><i class="fa fa-check-circle-o"
                        aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #4CAF50;"></i>
                    <!-- <i class="fa fa-times-circle-o" aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #D32F2F;"></i> -->
                    field actual <i class="fa fa-info-circle" aria-hidden="true"
                        style="font-size: 20px;margin: 3px;color: #03A9F4;"></i>
                </h5>
                <h5 *ngIf="check >= 3" class="form-lable"
                    style="font-size: 12px;font-weight: 500;color: #000 !important;"><i class="fa fa-check-circle-o"
                        aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #4CAF50;"></i>
                    <!-- <i class="fa fa-times-circle-o" aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #D32F2F;"></i> -->
                    field less/more <i class="fa fa-info-circle" aria-hidden="true"
                        style="font-size: 20px;margin: 3px;color: #03A9F4;"></i>
                </h5>
                <h5 *ngIf="check >= 4" class="form-lable"
                    style="font-size: 12px;font-weight: 500;color: #000 !important;"><i class="fa fa-check-circle-o"
                        aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #4CAF50;"></i>
                    <!-- <i class="fa fa-times-circle-o" aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #D32F2F;"></i> -->
                    Product name <i class="fa fa-info-circle" aria-hidden="true"
                        style="font-size: 20px;margin: 3px;color: #03A9F4;"></i>
                </h5>
                <h5 *ngIf="check >= 4" class="form-lable"
                    style="font-size: 12px;font-weight: 500;color: #000 !important;"><i class="fa fa-check-circle-o"
                        aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #4CAF50;"></i>
                    <!-- <i class="fa fa-times-circle-o" aria-hidden="true"
                        style="font-size: 30px  !important;position: relative;top: 6px;margin: 3px;color: #D32F2F;"></i> -->
                    Check Duplicates<i class="fa fa-info-circle" aria-hidden="true"
                        style="font-size: 20px;margin: 3px;color: #03A9F4;"></i>
                </h5>
                <hr />
                <h5 *ngIf="check >= 4" class="form-lable text-center"
                    style="font-size: 16px;color: #43A047 !important;">100% Completed
                </h5>
                <div *ngIf="check >= 4" class="text-center">
                    <button class="btn btn-primary" style="margin-right: 10px;"
                        (click)="acc_list()">Ok</button>

                </div>
                <!-- <h5 class="form-lable text-center" style="font-size: 16px;color: #D32F2F !important;">Failed</h5> -->

            </div>
        </div>
    </div>
</p-dialog>

<p-dialog header="Allocation Excel" [(visible)]="displayPosition2" *ngIf="displayPosition2" position="center" [modal]="true"
    [style]="{width: '60%'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="row" style="margin-left: 0px;margin-right: 0px; height:400px; overflow-x: scroll;">
      <app-autoaddfileds></app-autoaddfileds>
    </div>
</p-dialog>
